export const LIMIT_QUANTITY = 999;
export const MIN_QUANTITY = 0;
